import apiClient from '../api-client';
import type {
  WeeklyOperatingHours,
  CreateWeeklyOperatingHoursRequest,
  UpdateWeeklyOperatingHoursRequest
} from '@geely/shared/types';

export interface WeeklyOperatingHoursQueryParams {
  storeId: string;
  dayOfWeek?: number;
}

export const weeklyOperatingHoursApi = {
  list: (params: WeeklyOperatingHoursQueryParams) =>
    apiClient.get<WeeklyOperatingHours[]>('/weekly-operating-hours', { params }),

  create: (data: CreateWeeklyOperatingHoursRequest) =>
    apiClient.post<WeeklyOperatingHours>('/weekly-operating-hours', data),

  update: (id: string, data: UpdateWeeklyOperatingHoursRequest) =>
    apiClient.patch<WeeklyOperatingHours>(`/weekly-operating-hours/${id}`, data),

  delete: (id: string) =>
    apiClient.delete(`/weekly-operating-hours/${id}`),
};
